import { FC, useCallback } from 'react';
import ScanSection from 'src/components/scanner/ScanSection';
import useReceiptDetails from 'src/hooks/useReceiptDetails';
import useSplitter from 'src/hooks/useSplitter';

interface ReceiptSplitterProps {
  main: JSX.Element;
}

const ReceiptSplitter: FC<ReceiptSplitterProps> = ({ main }) => {
  const {
    receiptData,
    isReceiptLoading,
    recId,
    showScans,
    saveReceiptDetails,
    hasErrors,
    getReceiptData,
    isPoOpen,
  } = useReceiptDetails();
  const saveAndGetDocument = useCallback(async () => {
    if (!hasErrors && receiptData?.receiptStatus !== 'Deleted') {
      return saveReceiptDetails(true);
    } else {
      return getReceiptData();
    }
  }, [getReceiptData, hasErrors, receiptData?.receiptStatus, saveReceiptDetails]);

  return useSplitter(
    main,
    <ScanSection
      isPoOpen={isPoOpen}
      isInvoice={false}
      document={receiptData}
      isLoading={isReceiptLoading}
      id={recId}
      name={'receipt'}
      companyId={receiptData?.companyId?.toString() || ''}
      getDocument={saveAndGetDocument}
      isInvoiceProcessed={false}
    />,
    showScans,
    false
  );
};

export default ReceiptSplitter;
